/**
 * If the current environment is in development mode or not.
 */
export const DEV_MODE = process.env.NODE_ENV !== "production";
